export enum ConlicitasegTypes {
  GET_QUOTES_REQUEST = '@conlicitaseg/GET_QUOTES_REQUEST',
  GET_QUOTES_SUCCESS = '@conlicitaseg/GET_QUOTES_SUCCESS',
  GET_QUOTES_FAILURE = '@conlicitaseg/GET_QUOTES_FAILURE',
  SET_FORM_QUOTE = '@conlicitaseg/SET_FORM_QUOTE',
  SET_AUTOFILLED_FIELDS = '@conlicitaseg/SET_AUTOFILLED_FIELDS',
  CLEAR_FORM_QUOTE = '@conlicitaseg/CLEAR_FORM_QUOTE',
  CLEAR_COMPANY_DATA = '@conlicitaseg/CLEAR_COMPANY_DATA',
  CLEAR_RESUME_PROCESS = '@conlicitaseg/CLEAR_RESUME_PROCESS',
  SET_SELECTED_QUOTE_STORE = '@conlicitaseg/SET_SELECTED_QUOTE_STORE',
  SET_PAYMENT_INFO = '@conlicitaseg/SET_PAYMENT_INFO',
  SUBMIT_QUOTE_WITH_PAYMENT_REQUEST = '@conlicitaseg/SUBMIT_QUOTE_WITH_PAYMENT_REQUEST',
  SUBMIT_QUOTE_WITH_PAYMENT_SUCCESS = '@conlicitaseg/SUBMIT_QUOTE_WITH_PAYMENT_SUCCESS',
  SUBMIT_QUOTE_WITH_PAYMENT_FAILURE = '@conlicitaseg/SUBMIT_QUOTE_WITH_PAYMENT_FAILURE',
  SEARCH_COMPANY_DATA_REQUEST = '@conlicitaseg/SEARCH_COMPANY_DATA_REQUEST',
  SEARCH_COMPANY_DATA_SUCCESS = '@conlicitaseg/SEARCH_COMPANY_DATA_SUCCESS',
  SEARCH_COMPANY_DATA_FAILURE = '@conlicitaseg/SEARCH_COMPANY_DATA_FAILURE',
  CREATE_PROPOSAL_REQUEST = '@conlicitaseg/CREATE_PROPOSAL_REQUEST',
  CREATE_PROPOSAL_SUCCESS = '@conlicitaseg/CREATE_PROPOSAL_SUCCESS',
  CREATE_PROPOSAL_FAILURE = '@conlicitaseg/CREATE_PROPOSAL_FAILURE',
  GET_INSURED_REQUEST = '@conlicitaseg/GET_INSURED_REQUEST',
  GET_INSURED_SUCCESS = '@conlicitaseg/GET_INSURED_SUCCESS',
  GET_INSURED_FAILURE = '@conlicitaseg/GET_INSURED_FAILURE',
  GET_QUOTE_BY_ID_REQUEST = '@conlicitaseg/GET_QUOTE_BY_ID_REQUEST',
  GET_QUOTE_BY_ID_SUCCESS = '@conlicitaseg/GET_QUOTE_BY_ID_SUCCESS',
  GET_QUOTE_BY_ID_FAILURE = '@conlicitaseg/GET_QUOTE_BY_ID_FAILURE',
  CLEAR_REQUEST_STATE = '@conlicitaseg/CLEAR_REQUEST_STATE',
  CREATE_QUOTE_JUNTO_REQUEST = '@conlicitaseg/CREATE_QUOTE_JUNTO_REQUEST',
  CREATE_QUOTE_JUNTO_SUCCESS = '@conlicitaseg/CREATE_QUOTE_JUNTO_SUCCESS',
  CREATE_QUOTE_JUNTO_FAILURE = '@conlicitaseg/CREATE_QUOTE_JUNTO_FAILURE',
  CREATE_QUOTE_POTTENCIAL_REQUEST = '@conlicitaseg/CREATE_QUOTE_POTTENCIAL_REQUEST',
  CREATE_QUOTE_POTTENCIAL_SUCCESS = '@conlicitaseg/CREATE_QUOTE_POTTENCIAL_SUCCESS',
  CREATE_QUOTE_POTTENCIAL_FAILURE = '@conlicitaseg/CREATE_QUOTE_POTTENCIAL_FAILURE',
  CREATE_QUOTE_SOMBRERO_REQUEST = '@conlicitaseg/CREATE_QUOTE_SOMBRERO_REQUEST',
  CREATE_QUOTE_SOMBRERO_SUCCESS = '@conlicitaseg/CREATE_QUOTE_SOMBRERO_SUCCESS',
  CREATE_QUOTE_SOMBRERO_FAILURE = '@conlicitaseg/CREATE_QUOTE_SOMBRERO_FAILURE',
  CREATE_QUOTE_AVLA_REQUEST = '@conlicitaseg/CREATE_QUOTE_AVLA_REQUEST',
  CREATE_QUOTE_AVLA_SUCCESS = '@conlicitaseg/CREATE_QUOTE_AVLA_SUCCESS',
  CREATE_QUOTE_AVLA_FAILURE = '@conlicitaseg/CREATE_QUOTE_AVLA_FAILURE',
  CREATE_PROCESS_REQUEST = '@conlicitaseg/CREATE_PROCESS_REQUEST',
  CREATE_PROCESS_SUCCESS = '@conlicitaseg/CREATE_PROCESS_SUCCESS',
  CREATE_PROCESS_FAILURE = '@conlicitaseg/CREATE_PROCESS_FAILURE',
  CLEAR_QUOTES_BY_COMPANY = '@conlicitaseg/CLEAR_QUOTES_BY_COMPANY',
  UPDATE_QUOTE_JUNTO_REQUEST = '@conlicitaseg/UPDATE_QUOTE_JUNTO_REQUEST',
  UPDATE_QUOTE_JUNTO_SUCCESS = '@conlicitaseg/UPDATE_QUOTE_JUNTO_SUCCESS',
  UPDATE_QUOTE_JUNTO_FAILURE = '@conlicitaseg/UPDATE_QUOTE_JUNTO_FAILURE',
  UPDATE_QUOTE_POTTENCIAL_REQUEST = '@conlicitaseg/UPDATE_QUOTE_POTTENCIAL_REQUEST',
  UPDATE_QUOTE_POTTENCIAL_SUCCESS = '@conlicitaseg/UPDATE_QUOTE_POTTENCIAL_SUCCESS',
  UPDATE_QUOTE_POTTENCIAL_FAILURE = '@conlicitaseg/UPDATE_QUOTE_POTTENCIAL_FAILURE',
  UPDATE_QUOTE_SOMBRERO_REQUEST = '@conlicitaseg/UPDATE_QUOTE_SOMBRERO_REQUEST',
  UPDATE_QUOTE_SOMBRERO_SUCCESS = '@conlicitaseg/UPDATE_QUOTE_SOMBRERO_SUCCESS',
  UPDATE_QUOTE_SOMBRERO_FAILURE = '@conlicitaseg/UPDATE_QUOTE_SOMBRERO_FAILURE',
  UPDATE_QUOTE_AVLA_REQUEST = '@conlicitaseg/UPDATE_QUOTE_AVLA_REQUEST',
  UPDATE_QUOTE_AVLA_SUCCESS = '@conlicitaseg/UPDATE_QUOTE_AVLA_SUCCESS',
  UPDATE_QUOTE_AVLA_FAILURE = '@conlicitaseg/UPDATE_QUOTE_AVLA_FAILURE',
  SET_RESUME_PROCESS = '@conlicitaseg/SET_RESUME_PROCESS',
  CLEAR_SEARCH_COMPANY_DATA = '@conlicitaseg/CLEAR_SEARCH_COMPANY_DATA',
  CLEAR_SECOND_QUOTE_TRY = '@conlicitaseg/CLEAR_SECOND_QUOTE_TRY',
  SET_SECOND_QUOTE_TRY = '@conlicitaseg/SET_SECOND_QUOTE_TRY',
  CLEAR_CURRENT_PROCESS_ID = '@conlicitaseg/CLEAR_CURRENT_PROCESS_ID',
  GET_BIDDING_GUARANTEE_DATA_REQUEST = '@conlicitaseg/GET_BIDDING_GUARANTEE_REQUEST',
  GET_BIDDING_GUARANTEE_DATA_SUCCESS = '@conlicitaseg/GET_BIDDING_GUARANTEE_SUCCESS',
  GET_BIDDING_GUARANTEE_DATA_FAILURE = '@conlicitaseg/GET_BIDDING_GUARANTEE_FAILURE',
  GET_FIDELIZE_BIDDING_GUARANTEE_REQUEST = '@conlicitaseg/GET_FIDELIZE_BIDDING_GUARANTEE_REQUEST',
  GET_FIDELIZE_BIDDING_GUARANTEE_SUCCESS = '@conlicitaseg/GET_FIDELIZE_BIDDING_GUARANTEE_SUCCESS',
  GET_FIDELIZE_BIDDING_GUARANTEE_FAILURE = '@conlicitaseg/GET_FIDELIZE_BIDDING_GUARANTEE_FAILURE',
  SET_QUOTE_FLOW = '@conlicitaseg/SET_QUOTE_FLOW',
  SET_ORIGIN_CHANNEL = '@conlicitaseg/SET_ORIGIN_CHANNEL',
  CONSUME_FIDELIZE_LOGIN_REDIRECT = '@conlicitaseg/CONSUME_FIDELIZE_LOGIN_REDIRECT',
  MARK_FIDELIZE_EMAIL_LINK_APPLIED = '@conlicitaseg/MARK_FIDELIZE_EMAIL_LINK_APPLIED',
  SET_CONTRACT_UPLOADED = '@conlicitaseg/SET_CONTRACT_UPLOADED',
  GET_COMPANY_NAME_REQUEST = '@conlicitaseg/GET_COMPANY_NAME_REQUEST',
  GET_COMPANY_NAME_SUCCESS = '@conlicitaseg/GET_COMPANY_NAME_SUCCESS',
  GET_COMPANY_NAME_FAILURE = '@conlicitaseg/GET_COMPANY_NAME_FAILURE',
  GET_CLIENT_POLICYHOLDERS_REQUEST = '@conlicitaseg/GET_CLIENT_POLICYHOLDERS_REQUEST',
  GET_CLIENT_POLICYHOLDERS_SUCCESS = '@conlicitaseg/GET_CLIENT_POLICYHOLDERS_SUCCESS',
  GET_CLIENT_POLICYHOLDERS_FAILURE = '@conlicitaseg/GET_CLIENT_POLICYHOLDERS_FAILURE',
  CREATE_CLIENT_POLICYHOLDER_REQUEST = '@conlicitaseg/CREATE_CLIENT_POLICYHOLDER_REQUEST',
  CREATE_CLIENT_POLICYHOLDER_SUCCESS = '@conlicitaseg/CREATE_CLIENT_POLICYHOLDER_SUCCESS',
  CREATE_CLIENT_POLICYHOLDER_FAILURE = '@conlicitaseg/CREATE_CLIENT_POLICYHOLDER_FAILURE',
  CLEAR_COMPANY_NAME = '@conlicitaseg/CLEAR_COMPANY_NAME',
}

export type QuoteFlow = 'bidding' | 'dashboard' | 'dashboard_inactive' | 'fidelize';

export type OriginChannel = 'dashboard' | 'fidelize' | 'ia' | 'whatsapp';

export type GuaranteeType = 'participacao' | 'execucao' | null;

export type InsuranceStatus =
  | 'cotacao'
  | 'analise'
  | 'emitida'
  | 'vigente'
  | 'encerrada'
  | 'cancelada'
  | 'recusada'
  | 'expirada';

export interface InsuranceQuote {
  id: number;
  status_id: InsuranceStatus;
  selected_api_quote_id: string;
  insurance_company_id: string;
  payment_type: string;
  installments: string;
  due_date: string;
  proposal_id: string;
  premium_value: string;
  document_number: number;
  url_quote: string;
  draft_url: string;
  document_url: string;
  policy_number: string;
  policy_id: string;
  bill_url: string;
  insurance_process_id: number;
}

export interface Insured {
  id: number;
  cnpj: string;
  name: string;
  address: string;
  zip_code: string;
  number: string;
  district: string;
  city: string;
  state: string;
}

export interface FormProcessData {
  bidding_id: number | undefined;
  policyholder_cnpj: string;
  policyholder_company_name: string;
  type_warranty_id: string;
  bidding_modality: string;
  bidding_edict: string;
  bidding_contract_number: string;
  bidding_process_number: string;
  contract_days: number;
  contract_start_date: string;
  contract_end_date: string;
  contract_value: number;
  contract_percentage: number;
  contract_insured_amount: number;
  quote_date: string;
  insured_cnpj: string;
  insured_name: string;
  insured_address: string;
  insured_zip_code: string;
  insured_number: string;
  insured_district: string;
  insured_city: string;
  insured_state: string;
  policyholder_register_junto: boolean;
  policyholder_register_sombrero: boolean;
  policyholder_register_avla: boolean;
  contract_additional_value: number;
  policyholder_cnpj_matriz: string;
  origin_channel?: OriginChannel;
}

export interface InsuranceProcess {
  id: number;
  status: InsuranceStatus;
  insurance_quotes: InsuranceQuote[];
  selected_quote: InsuranceQuote;
  contact_id: number;
  client_id: number;
  insured: Insured;
  bidding_id: number | undefined;
  policyholder_cnpj: string;
  policyholder_company_name: string;
  type_warranty_id: string;
  bidding_modality: string;
  bidding_edict: string;
  bidding_contract_number: string;
  bidding_process_number: string;
  contract_days: number;
  contract_start_date: string;
  contract_end_date: string;
  contract_value: number;
  contract_percentage: number;
  contract_insured_amount: number;
  created_at: string;
  contract_additional_value: number;
  internal_process: boolean;
}

export interface ApiResponse {
  message: string;
  success: boolean;
}

export interface QuoteResponse {
  quote_response: InsuranceQuote;
  status: boolean;
}

export interface CompanyDataJunto {
  status: string;
  message: string;
  name: string;
  insurance_company_id: string;
}

export interface CompanyDataPottencial {
  status: string;
  message: string;
  name: string;
  insurance_company_id: string;
}

export interface CompanyDataSombrero {
  status: string;
  message: string;
  name: string;
  insurance_company_id: string;
}

export interface CompanyDataAvla {
  status: string;
  message: string;
  name: string;
  insurance_company_id: string;
}

export interface PolicyholderCompanyName {
  name: string;
  tipo_empresa: string;
  policyholder_cnpj_matriz: string;
  policyholder_public_legal_nature: boolean;
}

export interface InsuredData {
  insured_zip_code: string;
  insured_address: string;
  insured_number: string;
  insured_district: string;
  insured_city: string;
  insured_state: string;
  insured_name: string;
  insured_public_legal_nature: boolean;
}

export interface BiddingGuaranteeParticipacao {
  bidding_modality: string;
  bidding_edict: string;
  bidding_process_number: string;
  contract_days: number;
  contract_start_date: string;
  contract_percentage: number;
}

export interface BiddingGuaranteeExecucao {
  bidding_modality: string;
  bidding_edict: string;
  bidding_contract_number: string;
  bidding_process_number: string;
  contract_days: number;
  contract_percentage: number;
}

export interface SubimitQuote {
  selected_api_quote_id: string | undefined;
  contract_start_date: string;
  contract_end_date: string;
  payment_type: string;
  installments: string;
  contract_insured_amount: number;
  contract_days: number;
  due_date: string;
  insurance_company_id: string | undefined;
  insurance_process_id: number | undefined;
}

export interface RequestTypes {
  loading: boolean;
  loaded: boolean;
  error: boolean;
  errorMessage?: string;
  errorField?: string;
}

export type InsuranceCompany = 'junto' | 'pottencial' | 'sombrero' | 'avla';

export const INSURANCE_COMPANIES: InsuranceCompany[] = ['junto', 'pottencial', 'sombrero', 'avla'];

export interface InsuranceQuoteRequestState {
  junto: RequestTypes;
  pottencial: RequestTypes;
  sombrero: RequestTypes;
  avla: RequestTypes;
}

export interface ConlicitasegRequestState {
  get_quotes: RequestTypes;
  create_quote_by_company: InsuranceQuoteRequestState;
  submit_quote_with_payment: RequestTypes;
  search_company_data: RequestTypes;
  create_proposal: RequestTypes;
  get_insured: RequestTypes;
  get_quote_by_id: RequestTypes;
  create_process: RequestTypes;
  update_quote_by_company: InsuranceQuoteRequestState;
  get_bidding_guarantee_data: RequestTypes;
  get_fidelize_bidding_guarantee: RequestTypes;
  get_company_name: RequestTypes;
  get_client_policyholders: RequestTypes;
  create_client_policyholder: RequestTypes;
}

export interface ConlicitasegState {
  readonly request: ConlicitasegRequestState;
  readonly processes: InsuranceProcess[];
  readonly last_quotes: QuoteResponse[];
  readonly formProcess: FormProcessData;
  readonly selected_quote: Partial<InsuranceQuote>;
  readonly company_data_junto: CompanyDataJunto;
  readonly company_data_pottencial: CompanyDataPottencial;
  readonly company_data_sombrero: CompanyDataSombrero;
  readonly company_data_avla: CompanyDataAvla;
  readonly insured_data: InsuredData;
  readonly policyholder_register_junto: boolean;
  readonly policyholder_register_pottencial: boolean;
  readonly policyholder_register_sombrero: boolean;
  readonly policyholder_register_avla: boolean;
  readonly current_process_id: number | null;
  readonly resume_process: boolean;
  readonly second_quote_try: boolean;
  readonly quote_flow: QuoteFlow | null;
  readonly guarantee_type: GuaranteeType;
  readonly origin_channel: OriginChannel;
  readonly fidelize_login_redirect_pending: boolean;
  readonly fidelize_email_link_applied: boolean;
  readonly contract_uploaded: boolean;
  readonly get_company_name: PolicyholderCompanyName;
  readonly has_orgao_cnpj: boolean;
  readonly autofilled_fields: string[];
  readonly client_policyholders: string[];
}

export interface PolicyholderCompany {
  cnpj: string;
  company_name: string;
}
